// About when the moon rises tonight. A rough rule (moonrise is ~50 minutes
// later each day, near sunrise at new moon), good enough for a game window.
import { moonAgeSeconds } from '../sim/moon.js';

export function moonriseMinutes(iso) {
  const ageDays = moonAgeSeconds(iso) / 86400;
  return Math.round(6 * 60 + ageDays * 50.47) % (24 * 60);
}
// The 20 minutes after moonrise: the moon road (a better beach).
export function onMoonRoad(iso, now = new Date()) {
  const m = now.getHours() * 60 + now.getMinutes();
  const rise = moonriseMinutes(iso);
  const d = (m - rise + 1440) % 1440;
  return d >= 0 && d < 20;
}
export const hhmm = m => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
